module.exports = __webpack_public_path__ + "static/media/maharashtra_united.b9ebf4ba.png";